import { useLimitedList } from '@ucheba/utils/hooks/useLimitedList'
import { createContext, useCallback, useEffect, useMemo } from 'react'
import { useRouter } from 'next/router'
import {
  getFullRouterPath,
  objectToQueryString,
  redirect as redirectFunction,
} from '@ucheba/utils/helpers/router'
import { IUseLimitedListCore } from './types'

export const LimitedListContext = createContext({
  limitedItems: [] as any[],
  isOpen: false,
})

export const useLimitedListCore: IUseLimitedListCore = (props) => {
  const { limit, onShowAll, items, isAuth, id, redirect, showAllButtonLinkIsLink } = props
  const router = useRouter()

  const { limitedItems, showAll, countShowed } = useLimitedList({
    items,
    limit,
    onShowAll,
  })

  const isAuthNeed = useMemo(() => typeof isAuth === 'boolean', [isAuth])

  const onClickShowAll = useCallback(() => {
    if (showAllButtonLinkIsLink) {
      showAll()
      return
    }
    if (isAuthNeed) {
      if (isAuth && !redirect) {
        showAll()
      } else if (isAuth && redirect) {
        redirectFunction({ location: redirect })
      } else {
        const redirectUrl = redirect || `${router.asPath}#${id}`
        const location = getFullRouterPath(
          '/auth',
          objectToQueryString({ redirect: redirectUrl })
        )

        redirectFunction({ location })
      }
    } else {
      showAll()
    }
  }, [id, isAuth, isAuthNeed, redirect, router.asPath, showAll])

  useEffect(() => {
    if (isAuth && window.location.hash === `#${id}`) {
      showAll()
      router.replace(router.asPath.replace(/#\w+/g, ''), undefined, {
        shallow: true,
        scroll: false,
      })
    }
  }, [id, isAuth, router, showAll])

  return {
    limitedItems,
    countShowed,
    onClickShowAll,
    isAuthNeed,
  }
}
